import { render, staticRenderFns } from "./addPto2Modal.vue?vue&type=template&id=5c58a298&scoped=true&"
import script from "./addPto2Modal.vue?vue&type=script&lang=js&"
export * from "./addPto2Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c58a298",
  null
  
)

export default component.exports